
export const portfolioContent = {
  meta: {
    title: "Portfolio — ConX Orbit",
    description:
      "Selected client systems, internal products, and workflow solutions built for real-world construction and façade operations.",
  },
  hero: {
    badge: "SELECTED WORK",
    titleBefore: "Technology Built for ",
    titleHighlight: "Real-World",
    titleAfter: " Operations.",
    body: "From façade management platforms to AI-powered workflow automation, our work brings together industry knowledge, intelligent technology, and practical software engineering to solve complex operational problems.",
    line: "Client systems · Internal products · Emerging solutions",
  },
  featuredSlug: "panel-x",
  featured: {
    badge: "FEATURED WORK",
    label: "CLIENT SYSTEM",
    name: "",
    title: "Connecting Façade Operations From Shop to Site.",
    body: "",
    tags: [],
  },
  proof: {
    badge: "AT A GLANCE",
    items: [
      {
        value: "02",
        label: "Client Systems",
        hint: "Purpose-built platforms for live operations",
      },
      {
        value: "02",
        label: "Internal Products",
        hint: "Tools we're building for the industry",
      },
      {
        value: "04",
        label: "Workflow Capabilities",
        hint: "AI-assisted estimating to compliance",
      },
      {
        value: "06",
        label: "Industries",
        hint: "Deepest in the building envelope",
      },
    ],
  },
  clientSystems: {
    badge: "CLIENT SYSTEMS",
    title: "Built Around the Way Our Clients Work.",
    body: "We don't start with a template. We study the workflow, understand the operational problem, and engineer the system around it.",
  },
  approach: {
    badge: "HOW WE WORK",
    title: "From Operational Friction to Working Systems.",
    body: "Every engagement starts in the real workflow—then we design software that fits how teams already deliver.",
    steps: [
      {
        title: "Study the Workflow",
        body: "Map drawings, handoffs, bottlenecks, and site constraints before a single screen is designed.",
      },
      {
        title: "Engineer the System",
        body: "Build around the operational problem with clear data models, roles, and integration points.",
      },
      {
        title: "Embed in Operations",
        body: "Roll out with training, feedback loops, and support so the system sticks beyond go-live.",
      },
    ],
  },
  internalProducts: {
    badge: "Our Products",
    title: "Products We’re Building for the Industry",
    body: "Alongside client work, we’re developing our own products around recurring challenges we see across construction and specialist trades — turning real industry problems into focused, scalable technology.",
  },
  workflowSolutions: {
    badge: "Workflow Solutions",
    title: "Intelligence Applied to Real Workflows",
    body:
      "A collection of AI-powered workflow demonstrations built around real construction challenges, showing how repetitive and complex processes can be made faster, smarter, and more connected.",
  },
  industries: {
    badge: "INDUSTRY EXPERIENCE",
    titleLine1: "Deepest in the Building Envelope.",
    titleLine2: "Open to the Wider Built Environment.",
    items: [
      { label: "Façade & Curtain Walls", core: true },
      { label: "Aluminium" },
      { label: "Construction" },
      { label: "Electrical" },
      { label: "Engineering" },
      { label: "Project Operations" },
    ],
  },
  cta: {
    badge: "HAVE A PROBLEM WORTH SOLVING?",
    title: "Let's Build the System Behind Your Next Workflow.",
    body: "If you're dealing with a process that is too manual, too fragmented, or difficult to scale, let's explore what a purpose-built system could look like.",
    primary: { label: "Book a Consultation", href: "/book-discovery" },
    secondary: { label: "Explore Solutions", href: "/solutions" },
  },
};
